export default "__VITE_ASSET__ccacd520__"